import { render, staticRenderFns } from "./TorF.vue?vue&type=template&id=c1be080e&"
import script from "./TorF.vue?vue&type=script&lang=js&"
export * from "./TorF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports